
const MonthMapperoni = {
  '01': 'January',
  '02': 'February',
  '03': 'March',
  '04': 'April',
  '05': 'May',
  '06': 'June',
  '07': 'July',
  '08': 'August',
  '09': 'September',
  '10': 'October',
  '11': 'November',
  '12': 'December',
  '': 'Not Provided'
};

export const displayDate = (start='', finish='') => {
  const [start_y,start_m] = start.split('-');
  const [end_y, end_m] = finish.split('-');

  if(!start && !finish) {
    return 'Not Provided';
  }

  let from = start ? `${MonthMapperoni[start_m]} ${start_y}` :'Present';
  let to = finish ? `${MonthMapperoni[end_m]} ${end_y}` :'Present';

  return(
    `${from} - ${to}`
  );
};
